import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../lib/api-client";
import { queryKeys } from "../lib/queryClient";
import { POLL } from "../lib/polling";
import { TicketStatusBadge, TicketPriorityBadge } from "../components/StatusBadge";
import { EmptyState, ErrorBanner, LoadingState } from "../components/States";
import { formatDateTime } from "../lib/format";
import { usePageMeta } from "../lib/seo";

export function TicketsPage() {
  usePageMeta({
    title: "Support tickets",
    description: "Your support tickets with the MarketOnBase team.",
    path: "/tickets",
    index: false,
  });

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.tickets,
    queryFn: () => apiClient.getTickets({ limit: 50 }),
    refetchInterval: POLL.list,
  });

  return (
    <div className="stack">
      <div className="row row--between">
        <h1>Support tickets</h1>
        <Link to="/tickets/new" className="btn btn-primary">
          New ticket
        </Link>
      </div>

      {isLoading && <LoadingState label="Loading your tickets…" />}
      {isError && <ErrorBanner error={error} onRetry={() => void refetch()} />}

      {data && data.items.length === 0 && (
        <EmptyState title="No tickets yet">
          <Link to="/tickets/new" className="btn btn-primary">
            Open a support ticket
          </Link>
        </EmptyState>
      )}

      {data && data.items.length > 0 && (
        <div className="table-wrap card">
          <table>
            <thead>
              <tr>
                <th>Subject</th>
                <th>Status</th>
                <th>Priority</th>
                <th>Opened</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((t) => (
                <tr key={t.id}>
                  <td>
                    <Link to={`/tickets/${t.id}`}>{t.subject}</Link>
                  </td>
                  <td>
                    <TicketStatusBadge status={t.status} />
                  </td>
                  <td>
                    <TicketPriorityBadge priority={t.priority} />
                  </td>
                  <td>{formatDateTime(t.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
